'use strict';

import Collection from './collection.js';
import Coupon from 'newModels/coupon.js';

export default class Coupons extends Collection {
    url() {
        return '/Coupons';
    }

    initialize() {
        this.model = Coupon;
        super.initialize(...arguments);

        return this;
    }
}



// WEBPACK FOOTER //
// ./app/new-collections/coupons.js